import React, {FC} from 'react';
import {Student} from '../../shared/types/student';
import {getAllStudentsFetch} from '../../app/axios/studentFetches';
import HLModal, {HLModalSizeType} from '../../shared/components/modal/HLModal';
import HLPageTable, {HLPageTableFilterConfig} from '../../shared/components/table/HLPageTable';
import type {ColDef} from "ag-grid-community";

const searchFiltersConfig: HLPageTableFilterConfig<Student>[] = [
    {
        fieldName: 'firstName',
        label: 'Имя',
        operator: 'like',
    },
    {
        fieldName: 'lastName',
        label: 'Фамилия',
        operator: 'like',
    },
    {
        fieldName: 'telegram',
        label: 'Telegram',
        operator: 'like',
    },
    {
        fieldName: 'email',
        label: 'Email',
        operator: 'like',
    }
];

const columnDefs: ColDef<Student>[] = [
    {
        field: 'firstName',
        headerName: 'Имя',
    },
    {
        field: 'lastName',
        headerName: 'Фамилия',
        valueFormatter: (params) => params.value ?? '-',
    },
    {
        field: 'telegram',
        headerName: 'Telegram',
        valueFormatter: (params) => params.value ?? '-',
    },
    {
        field: 'email',
        headerName: 'Email',
        valueFormatter: (params) => params.value ?? '-',
    }
];

const defaultColDef: ColDef<Student> = {
    sortable: false,
    filter: false,
    resizable: true,
    flex: 1,
    minWidth: 100
};

interface StudentSearchModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onSelect: (student: Student) => void;
}

const StudentSearchModal: FC<StudentSearchModalProps> = ({
    open,
    setOpen,
    onSelect,
}) => {
    const handleRowClick = (params: any) => {
        if (params?.data) {
            onSelect(params.data);
            setOpen(false);
        }
    };

    const handleClose = () => setOpen(false)

    return (
        <HLModal open={open} onClose={handleClose} title="Выбрать ученика" sizeType={HLModalSizeType.LARGE}>
                <HLPageTable
                    title=""
                    columns={columnDefs}
                    defaultColDef={defaultColDef}
                    filterConfig={searchFiltersConfig}
                    actionButtons={[]}
                    fetchData={getAllStudentsFetch}
                    height={485}
                    onRowClick={handleRowClick}
                />
        </HLModal>
    );
};

export default StudentSearchModal; 